import {
  SlColorPicker
} from "./chunk.PSBQ3SJY.js";

// src/components/color-picker/color-picker.ts
var color_picker_default = SlColorPicker;
SlColorPicker.define("sl-color-picker");

export {
  color_picker_default
};
